import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4ad79eee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "content-banner-img",
  src: "https://img2.qiuwenxinli.com/official-website/join-us/banner-1.png"
})], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/join-us/join-info.png"
}, null, -1));
import MySeactionHeader from "@/components/common/my-seaction-header.vue";
import { useMeta } from "vue-meta";
import OfficeArea from "@/components/join-us/office-area.vue";
import ContactUs from "@/components/join-us/contact-us.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    useMeta({
      title: "加入我们",
      htmlAttrs: {
        lang: "en",
        amp: true
      },
      meta: [{
        name: "description",
        content: "用心理学幸福世界"
      }, {
        name: "kewords",
        content: "全民幸福社,幸福心理课,专业心理学导师教学,心理学读书"
      }]
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(MySeactionHeader, {
        title: "公司办公区"
      }), _createVNode(OfficeArea), _createVNode(MySeactionHeader, {
        title: "加入我们"
      }), _hoisted_3, _createVNode(ContactUs)]);
    };
  }
});